export default {
  most_popular: '#{{rank}} Más popular',
};
